/**
 * The in-app path a string names, or `null` when it does not name one: the answer to "is this
 * safe to hand to `navigate()` or a router `<Link to>` as a same-origin path?".
 *
 * `startsWith('/')` alone is not that test. `//evil.example.com` and `/\evil.example.com`
 * both start with a slash and both resolve cross-origin (the URL parser treats a backslash
 * like a slash). And tabs and newlines are stripped by the URL parser AFTER any check done
 * here, so `/\t//evil.example.com` would pass a character-position test and then resolve
 * cross-origin; they are removed first, and the value returned is the stripped one, so the
 * caller navigates to exactly what was checked.
 *
 * Extracted from `safeReturnTo` (`src/pages/PlaidOAuthReturn.tsx`), which now uses it, so
 * the two sites that ask this question share one rule (steward-app#1003).
 */
export function inAppPath(raw: string | null | undefined): string | null {
  const candidate = raw?.replace(/[\t\r\n]/g, '');
  if (!candidate || !candidate.startsWith('/')) return null;
  if (candidate[1] === '/' || candidate[1] === '\\') return null;
  return candidate;
}
